import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdAdd,
  MdArrowBack,
  MdArrowBackIosNew,
  MdArrowForward,
  MdArrowForwardIos,
  MdBookmark,
  MdBookmarkBorder,
  MdCheckCircle,
  MdCloud,
  MdFolder,
  MdMenu,
  MdOutlineShoppingCart,
  MdPerson,
  MdPersonOutline,
  MdShoppingCart,
} from "react-icons/md";

import "../styles/ConnectEmail.css";
import Spinner from "../components/Spinner";
import { useNavigate } from "react-router";
import { isEmpty } from "../functions/isEmpty";

export default function ConnectEmail({
  apiURL,
  isMobile,
  chats,
  scrollPositionHome,
  setScrollPositionHome,
  operators,
  user,
  searchString,
  setSearchString,
  setActiveOperator,
  activeOperator,
  documents,
  tasks,
  setActiveContact,
  setReloadConnections,
  reloadConnections,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [emailadress, setEmailAdress] = useState("");
  const [emailPass, setEmailPass] = useState("");
  const [thisChatsID, setThisChatsID] = useState(null);
  let navigate = useNavigate();

  useEffect(() => {
    if (isEmpty(user)) {
      navigate("/login");
    }
    setActiveContact(null);
  }, [user]);

  useEffect(() => {
    createNewChat();
  }, []);

  const handleClickConnect = async (email, password, users_id, chats_id) => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("email", email);
      formData.append("passwort", password);
      formData.append("users_id", users_id);
      formData.append("chats_id", chats_id);

      const response = await fetch(
        "https://cloud.ditochat.com/api/skills/createEmailConnection.php",
        {
          method: "POST",
          body: formData,
        }
      );

      const text = await response.text();
      console.log("Antwort vom Server:", text);

      // Suchen wir präzise nach dem wichtigen zweiten JSON Block:
      const startIndex = text.indexOf('{"status":"success"');

      if (startIndex === -1) {
        console.error("❌ Kein gültiger Erfolgs-Block gefunden.");
        fail();
        return;
      }

      const jsonString = text.slice(startIndex);

      let parsedData;
      try {
        parsedData = JSON.parse(jsonString);
      } catch (error) {
        console.error("❌ Fehler beim Parsen des Erfolgs-Blocks:", error);
        fail();
        return;
      }

      console.log("Geparstes Ergebnis:", parsedData);

      if (parsedData.pass_check === 1) {
        console.log("✅ Verbindung erfolgreich bestätigt.");
        success(parsedData);
      } else {
        console.error("❌ Verbindung fehlgeschlagen, pass_check !== 1.");
        fail(parsedData);
      }
    } catch (error) {
      console.error("❌ Netzwerk- oder Fetch-Fehler:", error);
      fail();
    } finally {
      setIsLoading(false);
    }
  };

  const doNothing = () => {
    return;
  };

  const success = (data) => {
    console.log("Success Funktion wurde aufgerufen:", data);
    // Hier kannst du später machen was du willst (z.B. navigate, speichern, anzeigen etc.)

    setReloadConnections(!reloadConnections);
    alert("Erfolg");
    navigate("/inbox");
  };

  const fail = (data) => {
    console.log("Fail Funktion wurde aufgerufen:", data);
    // Hier kannst du später Error-Messages zeigen oder etwas anderes tun

    alert("Fehler");
  };

  const createNewChat = async () => {
    try {
      const response = await fetch(apiURL + "/api/chats/createChat.php?", {
        method: "PUT",
        headers: {
          "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        body: JSON.stringify({
          users_id: user.id,
          operators_id: 2,
        }),
      });
      const text = await response.text();
      setThisChatsID(JSON.parse(text).id);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="connectEmail">
      <div className="connectEmail_topnav">
        <div className="connectEmail_topnav_back" onClick={() => navigate(-1)}>
          <ArrowBackIcon /> Email verbinden
        </div>
      </div>
      <div className="connectEmail_body">
        <input
          type="text"
          placeholder="Emailadresse"
          value={emailadress}
          onChange={(e) => setEmailAdress(e.target.value)}
          className="connectEmail_body_input"
        />
        <input
          type="text"
          placeholder="Passwort"
          value={emailPass}
          onChange={(e) => setEmailPass(e.target.value)}
          className="connectEmail_body_input"
        />
        <div
          className="connectEmail_body_cta"
          onClick={() =>
            isLoading
              ? doNothing()
              : handleClickConnect(emailadress, emailPass, user.id, thisChatsID)
          }>
          {isLoading ? <Spinner type="white" /> : "Verbinden"}
        </div>
      </div>
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 30px;
  color: #474747;
`;

const ArrowBackIcon = styled(MdArrowBackIosNew)`
  font-size: 15x;
  color: #717171;
`;

const ArrowForwardIcon = styled(MdArrowForward)`
  font-size: 15x;
  color: #717171;
`;

const CloudIcon = styled(MdFolder)`
  font-size: 18px;
  color: #474747;
`;

const CheckIcon = styled(MdCheckCircle)`
  font-size: 25px;
  color: #0072f5;
`;

const AddIcon = styled(MdAdd)`
  font-size: 23px;
  color: #0072f5;
`;

const FolderIcon = styled(MdFolder)`
  font-size: 23px;
  color: rgb(114, 114, 114);
`;

const AccountIcon = styled(MdPerson)`
  font-size: 23px;
  color: rgb(114, 114, 114);
`;
